module.exports = __webpack_public_path__ + "static/media/image-25-opacity.2d3c61f4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/movie/images/image-25-opacity.png
 ** module id = 418
 ** module chunks = 0
 **/